module.exports = __webpack_public_path__ + "img/nav-3.da460e95.png";